import { __assign } from '../../external/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Card } from '../../base/card/Card.js';
import { BillDue } from '../billDue/BillDue.js';
import { Button } from '../../base/button/Button.js';
import { SuccessIcon } from '../../icons/SuccessIcon.js';
import styles from './Bill.module.scss.js';
import { Skeleton } from './skeleton/Skeleton.js';

var getProductName = function (productType, productDetails) {
    if (productType === 'HDC1DOT0') {
        return 'Drivers Club 1.0 membership';
    }
    else if (productType === 'HDC1DOT5') {
        return 'Drivers Club membership';
    }
    else {
        return "".concat(productDetails[0].detailInfo).concat(productDetails && productDetails.length > 1 ? " +".concat(productDetails.length - 1) : '');
    }
};
var Bill = function (_a) {
    var _b, _c, _d;
    var bill = _a.bill, className = _a.className, style = _a.style, returnButtonLabel = _a.returnButtonLabel, returnUrl = _a.returnUrl, onPayClick = _a.onPayClick, onViewDetailsClick = _a.onViewDetailsClick, onAction = _a.onAction;
    var productType = bill.productType, formattedPrice = bill.formattedPrice, autoPayDetails = bill.autoPayDetails, productDetails = bill.productDetails, upcomingPaymentDetails = bill.upcomingPaymentDetails, isSubmitted = bill.isSubmitted;
    var isRecursive = !!autoPayDetails;
    var name = getProductName(productType, productDetails);
    var date = isRecursive ? autoPayDetails === null || autoPayDetails === void 0 ? void 0 : autoPayDetails.nextChargeDate : upcomingPaymentDetails === null || upcomingPaymentDetails === void 0 ? void 0 : upcomingPaymentDetails.date;
    var hasError = isRecursive
        ? ((_b = bill.autoPayDetails) === null || _b === void 0 ? void 0 : _b.informAboutFailure) && ((_c = bill.autoPayDetails) === null || _c === void 0 ? void 0 : _c.isFailed)
        : ((_d = bill.upcomingPaymentDetails) === null || _d === void 0 ? void 0 : _d.informAboutPastDue) && bill.upcomingPaymentDetails.isPastDue;
    var paymentUrl = '';
    if (!onPayClick && !isRecursive) {
        if (returnUrl) {
            var params = new URLSearchParams(__assign({ returnUrl: returnUrl }, (returnButtonLabel ? { returnButtonLabel: returnButtonLabel } : undefined)));
            paymentUrl = upcomingPaymentDetails.paymentUrl + '?' + params.toString();
        }
        else {
            paymentUrl = upcomingPaymentDetails.paymentUrl;
        }
    }
    var viewDetailsProps = onViewDetailsClick
        ? {
            onClick: function () {
                onViewDetailsClick(bill);
                onAction === null || onAction === void 0 ? void 0 : onAction('details', bill);
            },
        }
        : { as: 'a', href: autoPayDetails === null || autoPayDetails === void 0 ? void 0 : autoPayDetails.viewDetailsUrl, onClick: function () { return onAction === null || onAction === void 0 ? void 0 : onAction('details', bill); } };
    var payNowProps = onPayClick
        ? {
            onClick: function () {
                onPayClick(bill);
                onAction === null || onAction === void 0 ? void 0 : onAction('pay', bill);
            },
        }
        : { as: 'a', href: paymentUrl, onClick: function () { return onAction === null || onAction === void 0 ? void 0 : onAction('pay', bill); } };
    return (jsxs(Card, __assign({ as: "article", "aria-label": "bill", className: className, style: style }, { children: [jsx(Card.Title, { children: formattedPrice }), jsx(BillDue, { date: date, variant: isRecursive ? 'recursive' : 'single', hasError: hasError }), jsx(Card.Separator, {}), jsx("p", { children: name }), jsx(Card.Separator, {}), jsx("p", { children: isRecursive ? 'Monthly Payment Plan' : 'Annual premium' }), jsxs(Card.Footer, __assign({ as: "footer" }, { children: [isSubmitted && (jsxs("p", __assign({ className: styles.paymentSubmitted }, { children: [jsx(SuccessIcon, {}), " Payment submitted"] }))), !isSubmitted && isRecursive && (jsx(Button, __assign({ color: "secondary", size: "m" }, viewDetailsProps, { children: "View details" }))), !isSubmitted && !isRecursive && (jsx(Button, __assign({ size: "m" }, payNowProps, { children: "Pay now" })))] }))] })));
};
Bill.Skeleton = Skeleton;

export { Bill };
